{
  "AUDIT_LOGS": {
    "HEADER": "Auditní záznamy",
    "HEADER_BTN_TXT": "Přidat auditní záznamy",
    "LOADING": "Načítání auditních záznamů",
    "DESCRIPTION": "Auditní záznamy uchovávají záznam o aktivitách ve vašem účtu, což vám umožňuje sledovat a auditovat váš účet, tým nebo služby.",
    "LEARN_MORE": "Více o auditních záznamech",
    "SEARCH_404": "Neexistují žádné položky odpovídající tomuto dotazu",
    "SIDEBAR_TXT": "<p><b>Auditní záznamy</b> </p><p> Auditní záznamy jsou stopy událostí a akcí v systému. </p>",
    "LIST": {
      "404": "V tomto účtu nejsou k dispozici žádné auditní záznamy.",
      "TITLE": "Spravovat auditní záznamy",
      "DESC": "Auditní záznamy jsou stopy událostí a akcí v systému.",
      "TABLE_HEADER": {
        "ACTIVITY": "Uživatel",
        "TIME": "Akce",
        "IP_ADDRESS": "IP adresa"
      }
    },
    "API": {
      "SUCCESS_MESSAGE": "Auditní záznamy úspěšně načteny",
      "ERROR_MESSAGE": "Nelze se připojit k chat serveru, opakujte akci později"
    },
    "DEFAULT_USER": "Systém",
    "AUTOMATION_RULE": {
      "ADD": "{agentName} vytvořil nové automatizační pravidlo (#{id})",
      "EDIT": "{agentName} aktualizoval automatizační pravidlo (#{id})",
      "DELETE": "{agentName} smazal automatizační pravidlo (#{id})"
    },
    "ACCOUNT_USER": {
      "ADD": "{agentName} pozval {invitee} do účtu jako {role}",
      "EDIT": {
        "SELF": "{agentName} změnil své {attributes} na {values}",
        "OTHER": "{agentName} změnil {attributes} uživatele {user} na {values}",
        "DELETED": "{agentName} změnil {attributes} smazaného uživatele na {values}"
      }
    },
    "INBOX": {
      "ADD": "{agentName} vytvořil novou schránku (#{id})",
      "EDIT": "{agentName} aktualizoval schránku (#{id})",
      "DELETE": "{agentName} smazal schránku (#{id})"
    },
    "WEBHOOK": {
      "ADD": "{agentName} vytvořil nový webhook (#{id})",
      "EDIT": "{agentName} aktualizoval webhook (#{id})",
      "DELETE": "{agentName} smazal webhook (#{id})"
    },
    "USER_ACTION": {
      "SIGN_IN": "{agentName} se přihlásil",
      "SIGN_OUT": "{agentName} se odhlásil"
    },
    "TEAM": {
      "ADD": "{agentName} vytvořil nový tým (#{id})",
      "EDIT": "{agentName} aktualizoval tým (#{id})",
      "DELETE": "{agentName} smazal tým (#{id})"
    },
    "MACRO": {
      "ADD": "{agentName} vytvořil nové makro (#{id})",
      "EDIT": "{agentName} aktualizoval makro (#{id})",
      "DELETE": "{agentName} smazal makro (#{id})"
    },
    "INBOX_MEMBER": {
      "ADD": "{agentName} přidal {user} do schránky(#{inbox_id})",
      "REMOVE": "{agentName} odebral {user} ze schránky(#{inbox_id})"
    },
    "TEAM_MEMBER": {
      "ADD": "{agentName} přidal {user} do týmu(#{team_id})",
      "REMOVE": "{agentName} odebral {user} z týmu(#{team_id})"
    },
    "ACCOUNT": {
      "EDIT": "{agentName} aktualizoval konfiguraci účtu (#{id})"
    },
    "CONVERSATION": {
      "ADD": "{agentName} vytvořil konverzaci (#{id})",
      "EDIT": "{agentName} aktualizoval konverzaci (#{id}): {changes}"
    },
    "CONTACT": {
      "ADD": "{agentName} vytvořil kontakt (#{id})",
      "EDIT": "{agentName} aktualizoval kontakt (#{id}): {attributes}"
    }
  }
}
